import { useChannelContext } from "@sendbird/uikit-react/Channel/context";

import { ChatHeader } from "../../Chat/ChatHeader";

interface ClipboardGuidesChatHeaderTitleProps {
  onBack: () => void;
}

export function ClipboardGuidesChatHeaderTitle(
  props: ClipboardGuidesChatHeaderTitleProps
): JSX.Element {
  const { onBack } = props;
  const { currentGroupChannel } = useChannelContext();

  const workplaceName = (
    currentGroupChannel?.cachedMetaData as { facilityName?: string } | undefined
  )?.facilityName;

  return (
    <ChatHeader
      title={workplaceName ? `Community at ${workplaceName}` : "Community"}
      subtitle="Ask the regulars"
      onBack={onBack}
    />
  );
}
